// extracted by mini-css-extract-plugin
export default {"container":"Container_container__IQPAI","sm":"Container_sm__490Hy","md":"Container_md__xVW-z","lg":"Container_lg__qSOZQ","xl":"Container_xl__9nOML","\\32xl":"Container_-32xl__ztahi"};